import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../config/axios';
import { templeAssets } from '../config/assets';

const SiteConfigContext = createContext();

export const useSiteConfig = () => useContext(SiteConfigContext);

export const SiteConfigProvider = ({ children }) => {
    const [config, setConfig] = useState({
        ...templeAssets,
        // Ensure nested objects are initialized if not in assets
        templeImages: templeAssets.templeImages || {},
        logoText: templeAssets.logoText || {}
    });
    const [loading, setLoading] = useState(true);

    // Map backend keys to frontend config structure
    // SiteConfig keys: 'logo', 'logo_footer', 'hero_image', 'home_slider' (array)
    const mapConfigToState = (backendConfig) => {
        const newConfig = { ...templeAssets }; // Start with defaults

        if (backendConfig.logo) newConfig.logo = backendConfig.logo;
        if (backendConfig.logo_footer) newConfig.logoFooter = backendConfig.logo_footer;
        if (backendConfig.hero_image) newConfig.heroImage = backendConfig.hero_image;

        // Helper to parse array
        const toArray = (val) => {
            if (Array.isArray(val)) return val;
            if (typeof val === 'string') {
                try {
                    const parsed = JSON.parse(val);
                    if (Array.isArray(parsed)) return parsed;
                } catch (e) {}
            }
            return [];
        };

        // Slider
        if (backendConfig.home_slider) {
            newConfig.bannerImages = toArray(backendConfig.home_slider);
        }

        // Temple Images (gallery preview and about section)
        newConfig.templeImages = {
            ...newConfig.templeImages,
            ...(backendConfig.temple_images_main && { main: backendConfig.temple_images_main }),
            ...(backendConfig.about_temple_main && { gopuram: backendConfig.about_temple_main }),
            ...(backendConfig.about_temple_shrine && { deity: backendConfig.about_temple_shrine })
        };

        if (backendConfig.home_gallery) {
            newConfig.homeGalleryImages = toArray(backendConfig.home_gallery);
        }

        return newConfig;
    };

    const fetchConfig = useCallback(async () => {
        try {
            const { data } = await api.get('/api/site-config');
            if (data) {
                setConfig(prev => ({
                    ...prev,
                    ...mapConfigToState(data)
                }));
            }
        } catch (error) {
            console.error('Failed to fetch site config:', error);
            // Fallback to defaults (already set)
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchConfig();
    }, [fetchConfig]);



    return (
        <SiteConfigContext.Provider value={{ config, loading, refreshConfig: fetchConfig }}>
            {children}
        </SiteConfigContext.Provider>
    );
};
